export enum EventCategory {
  WORKSHOP = 'workshop',
  SURVEY = 'survey',
  OTHER = 'other',
}

export enum ParticipationStatus {
  REGISTERED = 'Angemeldet',
  ATTENDED = 'Teilgenommen',
}

export enum AvailabilityStatus {
  FULLYBOOKED = 'Ausgebucht',
  WAITLIST = 'Warteliste',
}

export enum ResidencePlace {
  URBAN = 'Stadtumgebung',
  RURAL = 'Ländlich',
  UNSPECIFIED = 'Keine Angabe',
}

export enum SalutationStatus {
  MR = 'Herr',
  MS = 'Frau',
  MX = 'Neutral',
}

export function stringToSalutationStatus(value: string): SalutationStatus | undefined {
  return Object.values(SalutationStatus).find(v => v === value);
}

export interface IUserInterestsProfile {
  id: string;
  salutation: SalutationStatus;
  firstName: string;
  lastName: string;
  email: string;
  telefonCountryCode: string;
  telefonNumber: string;
  birthyear: string;
  placeOfResidence: ResidencePlace;
}

export interface CommunityEvent {
  id: string;
  title: string;
  type: EventCategory;
  participationStatus?: ParticipationStatus;
  availabilityStatus?: AvailabilityStatus;
  details?: string;
  description?: string;
}

export interface CommunityEventDetails extends CommunityEvent {
  detailedDescription: string;
  location: string;
  startDate: string;
  endDate: string;
  isAnyTimePossible: boolean;
  participants?: {
    maximumCapacity: number;
    registered: number;
    waitlisted: number;
  };
}
